module.exports = __webpack_public_path__ + "img/selected6-min.bba0ef9d.png";